// Global demo mode status, persisted in localStorage so it survives reloads.
// Activated via ?demo=true (see DataImport) or the Settings toggle.
export const LOCAL_STORAGE_DEMO_KEY = 'demoMode';
/** Read the persisted demo mode flag (defaults to false). */
export function loadDemoMode() {
    try {
        return localStorage.getItem(LOCAL_STORAGE_DEMO_KEY) === 'true';
    }
    catch {
        return false;
    }
}
/** Persist the demo mode flag. */
export function saveDemoMode(value) {
    try {
        localStorage.setItem(LOCAL_STORAGE_DEMO_KEY, value ? 'true' : 'false');
    }
    catch {
        // ignore storage errors (e.g. private mode)
    }
}
